import { throttle, APIConfig } from '../config';
import { wait } from '../utils/wait';
import axiosClient from '../utils/axios-client';

class IfscApi {
  // get bankDetails by ifscCode
  private channelPartnerApiUrl = APIConfig.channelPartnerApiUrl;

  async getBankDetailsByIfscCode(ifscCode: string):
  Promise<{ responseData: any, statusCode: number }> {
    if (throttle) {
      await wait(throttle);
    }
    try {
      const res = await axiosClient.get(`${this.channelPartnerApiUrl}ifsc/${ifscCode}`);
      return await Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (err) {
      console.error(err);
      return Promise.resolve({
        responseData: err.response.data,
        statusCode: err.response.status
      });
    }
  }
}

export const ifscApi = new IfscApi();
